import { createComponent } from '@carvana/merch-components';

export const Main = createComponent('main', {
  className: 'mx-auto w-full bg-canvas-default pb-4xl sm:pb-8xl'
});

export const Section = createComponent('section', {
  className: 'max-w-[1272px] u:mx-auto'
});

export const EvGuideSection = createComponent(Section, {
  className: 'u:px-2xl u:py-6xl sm:px-3xl md:py-8xl lg:px-0'
});

export const Content = createComponent('p', {
  className: 'text-text-default t-body-md md:t-body-lg'
});

export const Title = createComponent('h1', {
  className: 'text-text-strong t-heading-2xl sm:t-heading-3xl'
});

export const Subtitle = createComponent('h3', {
  className: 'text-text-strong t-heading-lg'
});

export const Divider = createComponent('div', {
  className: 'mx-2xl border-b border-border-weak sm:mx-3xl md:mx-8xl'
});
